import React from "react";
import ProjectsList from "./ProjectsList";
import TeamMembers from "./TeamMembers";

export default function SideBar() {
  return (
    <div className="sidebar">
      <ProjectsList />
      <TeamMembers />
    </div>
  );
}
